import React from "react";
import "./serviceOM.css";
import Topbar from "../../components/Topbar/Topbar";
import Footer from "../../components/Footer/Footer";
import Offline from "../../components/Offline/Offline";

const ServiceOM = () => {
    return (
        <>
            <Topbar />
            <div className="serviceOM-container">
                <Offline />
                <Footer />
            </div>
        </>
    )
}

export default ServiceOM;